import z from "zod";

export const createAnnouncementAttachmentArgsSchema = z.object({
  courseId: z.string(),
  itemId: z.string(),
  addOnToken: z.string(),
  title: z.string(),
  lessonSlug: z.string(),
  programmeSlug: z.string(),
  unitSlug: z.string(),
  maxPoints: z.number().optional(),
  teacherLoginHint: z.string().optional(),
});

export type CreateAnnouncementAttachmentArgs = z.infer<
  typeof createAnnouncementAttachmentArgsSchema
>;

export const classroomAttachmentSchema = z.object({
  courseId: z.string(),
  postId: z.string(),
  id: z.string(),
  title: z.string(),
  teacherViewUri: z.object({
    uri: z.string(),
  }),
  studentViewUri: z.object({
    uri: z.string(),
  }),
  studentWorkReviewUri: z
    .object({
      uri: z.string(),
    })
    .optional(),
  itemId: z.string(),
  maxPoints: z.number().nullish(),
});

export type ClassroomAttachment = z.infer<typeof classroomAttachmentSchema>;

export const createCourseWorkArgsSchema = z.object({
  title: z.string(),
  description: z.string().optional(),
  lessonUrl: z.string(),
  maxPoints: z.number().int().positive(),
});

export type CreateCourseWorkArgs = z.infer<typeof createCourseWorkArgsSchema>;

export const courseWorkCreatedResultSchema = z.object({
  courseWorkId: z.string(),
  courseId: z.string(),
  alternateLink: z.string().optional(),
  title: z.string(),
});

export type CourseWorkCreatedResult = z.infer<
  typeof courseWorkCreatedResultSchema
>;

export const courseListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  section: z.string().optional(),
});

export type CourseListItem = z.infer<typeof courseListItemSchema>;
